module.exports = __webpack_public_path__ + "static/img/int6.41db10e9.jpg";